import { IUser } from "@models/user.model";
import { User } from "firebase/auth";
import { createContext } from "react";

export const AuthContext = createContext<null | {
  user: IUser;
  authUser: User;
}>(null);
